import Swal from 'sweetalert2'
import SearchNoInfoIcon from '../../../../../assets/icons/search-no-info.svg'
import { NO_INFORMATION_TEXT } from './constants'

export const NoInformationFound = (isCurrentDate, type) => {
  return Swal.fire({
    imageWidth: 64,
    imageHeight: 64,
    iconHtml: `<img src='${SearchNoInfoIcon}' />`,
    title: NO_INFORMATION_TEXT[type](isCurrentDate).title,
    html: NO_INFORMATION_TEXT[type](isCurrentDate).body,
    customClass: { container: 'no-circle NoInformationFound', confirmButton: 'primaryButton', icon: 'withoutCloseButton' },
    confirmButtonText: 'Fechar',
    confirmButtonColor: '#01878E'
  })
}
